module.exports = __webpack_public_path__ + "img/fig9.15.b3012dbb.png";